const getSeoCategoryImageUrl = (path: string) => {
  if (!path) {
    return "";
  }
  let resolvedPath = path;
  if (!resolvedPath.startsWith("/")) {
    resolvedPath = `/${resolvedPath}`;
  }
  if (resolvedPath.startsWith("/images")) {
    return resolvedPath;
  }
  return resolvedPath.startsWith("/uploads/seo_category") ? `https://cdnimg.webstaurantstore.com${resolvedPath}` : `https://cdnimg.webstaurantstore.com/uploads/seo_category${resolvedPath}`;
};
export default getSeoCategoryImageUrl;